module.exports = __webpack_public_path__ + "img/kinkaku.781545e5.jpg";